import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { CollapseModule } from 'ngx-bootstrap/collapse';

import { InfoModule } from '@shared/info/info.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { NotifySettingModule } from '@shared/notify-setting/notify-setting.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';

import { AppLayoutComponent } from './pages';
import {
  BatchReviewComponent,
  ContentHeaderComponent,
  HeaderActionsComponent,
  HeaderActionsMobileComponent,
  HeaderBadgeComponent,
  HeaderComponent,
  HeaderStatusComponent,
  LastLoginAttemptComponent,
  MonthBillFailedComponent,
  SettingSidebarComponent,
  SidebarComponent,
  UserWarningsComponent,
} from './components';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MutualModule } from '@shared/mutual/mutual.module';
import { LclMutualModule } from '@shared/lcl-mutual';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { HintTooltipDirective } from '@shared/tooltip/directives';
import { InternalNotesModule } from '@shared/internal-notes/internal-notes.module';
import { GlobalAlertModule } from '@shared/global-alert/global-alert.module';
import { TrustpilotWidgetModule } from '@app/modules/auth/components/trustpilot-widget/trustpilot-widget.module';
import { CompanySharedModule } from '@shared/company-shared/company-shared.module';

@NgModule({
  declarations: [
    AppLayoutComponent,
    SidebarComponent,
    LastLoginAttemptComponent,
    HeaderComponent,
    SettingSidebarComponent,
    ContentHeaderComponent,
    HeaderActionsComponent,
    HeaderActionsMobileComponent,
    HeaderStatusComponent,
    HeaderBadgeComponent,
    UserWarningsComponent,
    BatchReviewComponent,
    MonthBillFailedComponent,
  ],
  imports: [
    CommonModule,
    MutualModule,
    TranslateModule,

    InternalNotesModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    InfoModule,
    PipesSharedModule,
    FormWrapperModule,
    NotifySettingModule,
    CustomModalModule,
    RouterModule,
    CollapseModule,
    FlexLayoutModule,
    LclMutualModule,
    NzToolTipModule,
    GlobalAlertModule,
    TrustpilotWidgetModule,
    CompanySharedModule,
  ],
  exports: [AppLayoutComponent],
  providers: [HintTooltipDirective],
})
export class AppLayoutModule {}
